import {putAll, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {showBeError} from 'utils/show-be-error';

import {adminAction, GetAuthDiscriminatorOptionsAction} from '../action';

function* execute(_: GetAuthDiscriminatorOptionsAction): SagaIterator {
    const response = yield* call(Api.findAllDiscriminators);

    if (response.isSuccess) {
        yield* put(adminAction.setAuthDiscriminators(response.data));
    } else {
        yield putAll(showBeError(response, t('admin')('discriminatorLoadingError')));
    }
}
/** Runs the admin saga that loads discriminator options for permission forms. */
export function* getAuthDiscriminatorOptionsSaga(): SagaIterator {
    yield takeLatestF('admin/GET_AUTH_DISCRIMINATOR_OPTIONS', execute);
}
